<template>
  <div>
    <div class="section" style="min-width: 1200px;">
      <div style="display:flex;flex-direction:column">
        <div v-if="job.multipleDischargingPickups">
          <cargo-ag-grid
            v-if="top.visible"
            no="1"
            config-module="130146"
            :grid-options="top.gridOptions"
            :grid-params.sync="top.gridParams"
            :column-defs="top.columnDefs"
            :row-data="trucking"
            style="width:100%;"
            @gridReady="params=>{topgridApi=params.api}"
          />
        </div>
        <div v-if="job.multipleDischargingPickups" class="app-main-inner-row operations" style="padding:5px 0">
          <div v-show="cooperateEdit" class="triggers">
            <div>
              <el-button no="2" type="primary" :disabled="readonly" @click="copyNewHandler">{{
                $t('SeaExport.copyAndAddPoItems')
              }}
              </el-button>
              <el-button no="3" type="primary" :disabled="readonly" @click="addHandler">{{
                $t('SeaExport.Add2')
              }}
              </el-button>
              <el-button no="4" :disabled="!btnEnable.btDel " type="danger" @click="delHandler">{{
                $t('SeaExport.Delete')
              }}
              </el-button>
            </div>
          </div>
        </div>
        <el-divider v-if="job.multipleDischargingPickups" />
        <el-form :inline="true" class="inline-form" label-width="100px" label-position="left">
          <el-form-item>
            <template>
              <el-checkbox v-model="job.multipleDischargingPickups" no="5.1" :disabled="readonly" style="width: auto;" @change="multiPickupsChangeHandler">{{
                $t('SeaExport.MultiDoors') }}
              </el-checkbox>
            </template>
          </el-form-item>
        </el-form>
        <el-form :inline="true" class="inline-form" label-width="140px" label-position="left">
          <el-form-item>
            <label style="width: 55px">{{ $t('SeaExport.Quantity') }}</label>
            <el-input-number
              no="6"
              :value="truckingInfo.quantity||0"
              :disabled="readonly"
              :min="0"
              :max="99999"
              :precision="0"
              controls-position="right"
              style="width: 118px"
              @input="val=>{truckingInfo.quantity=val}"
            />
            <label style="width: 55px">{{ $t('SeaExport.Weight') }}</label>
            <el-input-number
              no="7"
              :value="truckingInfo.weight||0.000"
              :disabled="readonly"
              :min="0"
              :max="99999"
              :precision="3"
              controls-position="right"
              style="width: 118px"
              @input="val=>{truckingInfo.weight=val}"
            />
            <label style="width: 55px">{{ $t('SeaExport.Cubage') }}</label>
            <el-input-number
              no="8"
              :value="truckingInfo.cubage||0.000"
              :disabled="readonly"
              :min="0"
              :max="99999"
              :precision="3"
              controls-position="right"
              style="width: 118px"
              @input="val=>{truckingInfo.cubage=val}"
            />
          </el-form-item>
        </el-form>

        <div class="trucking-form">
          <el-form :disabled="readonly" label-width="140px" label-position="left">
            <el-form-item :label="$t('SeaExport.HaulageCompany')" class="custom">
              <cargo-company-select
                no="9"
                :disabled="readonly"
                :method-params="{truckCmp:true,active:true,companyLob:'integratedJob'}"
                :default-value="truckingInfo.carryingCmp||''"
                style="width:400px; display:inline-block"
                @change="p=>{truckingInfo.carryingCmp=p.value||0;carryingCmpChangeHandler()}"
              />
            </el-form-item>

            <el-form-item :label="$t('SeaExport.HaulageContactPerson')" class="custom">
              <el-select
                v-model="truckingInfo.driver"
                no="10"
                style="width:400px"
                :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
                :allow-create="true"
                :clearable="true"
                filterable
                @change="carryingContactsChangeHandler(false, false)"
                @blur="selectContactBlur"
              >
                <el-option
                  v-for="(item,index) in carryingContacts"
                  :key="index"
                  :label="item.contactPerson"
                  :value="item.contactPerson"
                />
              </el-select>
            </el-form-item>

            <el-form-item class="custom" :label="$t('SeaExport.EstPackingDate')">
              <el-date-picker
                v-model="truckingInfo.loadingDate"
                no="11"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width:400px"
                @change="changeReplacementTime(false)"
              />
            </el-form-item>
            <el-form-item class="custom" :label="$t('SeaExport.ExpectedArrivalDate2')">
              <el-date-picker
                v-model="ieTruckInfo.arriveDate"
                no="11"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width:400px"
                @change="changeDischargeTime(false)"
              />
            </el-form-item>
            <el-form-item :label="$t('Warehouse.Driver')" :disabled="isEdit" class="custom">
              <el-input
                v-model="truckingInfo.driverName"
                no="12"
                style="width:400px;"
              />
            </el-form-item>
            <el-form-item :label="$t('Warehouse.DriverPhone')" :disabled="isEdit" class="custom">
              <el-input
                v-model="truckingInfo.driverPhone"
                no="45"
                :disabled="readonly"
                style="width:400px;"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_VehicleModel')" class="custom">
              <cargo-advance-select
                no="vehicleType"
                :select-type="selectTypeNames.basic_data_VehicleModel"
                filterable
                :show-custom-label-in-option="true"
                :custom-label="vehicleTypeLabel"
                :method-params="{typeKh:true}"
                style="width:400px;"
                :clearable="false"
                :default-value="ieTruckInfo.vehicleType"
                @parentCallBack="p=>{ieTruckInfo.vehicleType=p.value;}"
              />
            </el-form-item>
          </el-form>

          <el-form label-width="140px" label-position="left">
            <el-form-item class="custom" :label="$t('SeaExport.HaulageNo')">
              <el-input
                v-model="truckingInfo.truckOrderNo"
                no="19"
                :disabled="readonly"
                style="width:160px"
                @change="refreshGrid"
              />
              <label>{{ $t('SeaExport.HaulageCharge') }}</label>
              <el-input-number
                v-model="truckingInfo.truckingFee"
                no="40"
                :disabled="readonly"
                :min="0"
                :max="999999999999"
                :precision="2"
                controls-position="right"
                style="width:120px"
                @change="truckingFeeCharge"
              />
              <span class="currency">{{ localCurrency }}</span>
            </el-form-item>

            <el-form-item class="custom" :label="$t('SeaExport.Tel')">
              <el-input
                v-model="truckingInfo.driverTel"
                no="41"
                :disabled="readonly"
                style="width:400px"
                @change="refreshGrid"
              />
            </el-form-item>

            <el-form-item class="custom" :label="$t('SeaExport.ActPackingDate')">
              <el-date-picker
                v-model="truckingInfo.actLoadingDate"
                no="42"
                :disabled="readonly"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width:400px"
                @change="changeReplacementTime(true)"
              />
            </el-form-item>

            <el-form-item class="custom" :label="$t('SeaExport.ActualArrivalDate')">
              <el-date-picker
                v-model="ieTruckInfo.actualArrivalDate"
                no="42"
                :disabled="readonly"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width:400px"
                @change="changeDischargeTime(true)"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlateNumber')" class="custom">
              <el-input
                v-if="isEdit"
                v-model="truckingInfo.plateNumber"
                no="43"
                :disabled="readonly"
                style="width:400px;"
                @input="(val)=>{truckingInfo.plateNumber = val.trim()}"
              />
              <span v-if="readonly" class="plate_number">{{ truckingInfo.plateNumber }}</span>
            </el-form-item>

            <el-form-item :label="$t('CargoMsg.Cargo_trailerNumber')" :disabled="isEdit" class="custom">
              <el-input
                v-model="ieTruckInfo.trailerNumber"
                no="45"
                :disabled="readonly"
                style="width:400px;"
              />
            </el-form-item>
            <el-form-item class="custom" :label="$t('SeaExport.travelTime')">
              <el-input-number
                v-model="truckingInfo.travelHour"
                :disabled="readonly"
                no="13"
                :min="0"
                controls-position="right"
                style="width:105px"
              />
              <span style="margin:10px">{{ $t('SeaExport.Hour') }}</span>
              <el-input-number
                v-model="truckingInfo.travelMinute"
                :disabled="readonly"
                no="14"
                :min="0"
                :max="59"
                controls-position="right"
                style="width:100px"
              />
              <span style="margin:10px">{{ $t('SeaExport.Minute') }}</span>
            </el-form-item>
          </el-form>
        </div>
        <el-divider />
        <div style="font-weight: bold;padding-left: 20px;padding-bottom:10px;">
          <span class="title"> {{ $t('SeaExport.DestinationGatePoint') }}</span>
        </div>
        <!--   门到门   目的地门点    -->
        <div class="trucking-form">
          <el-form label-width="140px" label-position="left">
            <!--   目的地门点-->
            <el-form-item :label="$t('SeaExport.Door')" class="custom">
              <cargo-advance-select
                filterable
                :cache="false"
                :allow-create="true"
                :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
                :disabled="readonly"
                tag-name="name"
                tag-value="name"
                :default-value="ieTruckInfo.doorName"
                :static-options="doorList"
                :filter-tag-names="['name']"
                style="width: 400px"
                @parentCallBack="doorsChange2Handler"
              />
            </el-form-item>
            <!--   目的地门点地址-->
            <el-form-item :label="$t('SeaExport.DoorAddress')" class="custom">
              <el-input
                v-model="ieTruckInfo.doorAddress"
                no="16"
                :disabled="readonly"
                type="textarea"
                :rows="3"
                style="width:400px"
              />
            </el-form-item>
            <el-form-item class="auto-width" label-width="0">
              <div style="display: flex;">
                <!--   目的地门点城市-->
                <el-form-item class="custom" :label="$t('Pricing.BelongingCity')">
                  <cargo-advance-select
                    no="17"
                    style="width:160px"
                    :disabled="readonly"
                    :tag-name="$store.getters.language === 'zh' ? 'chineseName' : 'englishName'"
                    tag-value="code"
                    :cache="false"
                    filterable
                    :default-value="ieTruckInfo.cityCode"
                    :static-options="cityList"
                    :placeholder="$t('SeaExport.PleaseSelect')"
                    @parentCallBack="p=>ieTruckInfo.cityCode=p.value"
                  />
                </el-form-item>
                <el-form label-width="100px" label-position="left">
                  <!--   托盘数量-->
                  <el-form-item class="custom" :label="$t('Warehouse.PalletSum')">
                    <el-input-number
                      no="18"
                      style="width:140px;"
                      :value="ieTruckInfo.palletSum"
                      :disabled="readonly"
                      :min="0"
                      :max="999999999999"
                      :precision="0"
                      :controls="false"
                      @input="val=>{ieTruckInfo.palletSum=val || 0}"
                    />
                  </el-form-item>
                </el-form>
              </div>
            </el-form-item>
            <el-form-item label="PO">
              <el-input
                v-model="ieTruckInfo.po"
                no="po"
                :disabled="readonly"
                :filter-chars="false"
                type="textarea"
                :rows="3"
                style="width:400px"
              />
            </el-form-item>
          </el-form>
          <el-form label-width="140px" label-position="left">
            <!--   目的地门点联系 -->
            <el-form-item :label="$t('SeaExport.DoorContactPerson')" class="custom">
              <el-input v-model="ieTruckInfo.doorMan" no="15" style="width:400px" :disabled="readonly" />
            </el-form-item>
            <!--   目的地门点电话 -->
            <el-form-item class="custom" :label="$t('SeaExport.Tel')">
              <el-input v-model="ieTruckInfo.doorManTel" no="46" :disabled="readonly" style="width:400px" />
            </el-form-item>
            <!--   目的地门点卸货方式 -->
            <el-form-item :label="$t('CargoMsg.DischargingWay')">
              <el-select
                :value="ieTruckInfo.dischargingWay?ieTruckInfo.dischargingWay.split(','):[]"
                no="48"
                :disabled="readonly"
                multiple
                style="width:400px"
                @input="value=>{ieTruckInfo.dischargingWay=value.join(',')}"
              >
                <el-option value="DROP" />
                <el-option value="LIVE UNLOAD" />
                <el-option value="EXCHANGE PALLETS" />
              </el-select>
            </el-form-item>
            <!--   最晚送货日期 -->
            <el-form-item :label="$t('CargoMsg.LatestDeliveryDate')">
              <el-date-picker
                v-model="ieTruckInfo.actDeliveryDate"
                no="actDeliveryDate"
                :disabled="readonly"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width:400px"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cache, cacheName } from '@/utils/cacheManager'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { Job } from '@/class/model/booking/Job'
import StrUtils from '@/utils/StrUtils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { IntegratedJob } from '@/class/model/booking/IntegratedJob'
import { Company } from '@/class/model/mdm/Company'
import { addSites, getSites, getWarehouseDetail } from '@/api/company'
import ColumnUtils from '@/utils/ColumnUtils'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import SoNoSelector from '@/components/Cargo/Job/soNoSelector'
import { TabError } from '@/utils/class/TabError'
import { DocumentManage } from '@/utils/commonUtil'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { ensureExecuteSuccess } from '@/utils/commonUtil'
import CargoDateTimeFieldInput from '@/components/Cargo/Common/cargoDateTimeFieldInput'
import cargoRepeatValueSelect from '@/components/Cargo/Common/cargoRepeatValueSelect'
import { getLocationList } from '@/api/location'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { IntegratedTruckingInfo } from '@/class/model/booking/IntegratedTruckingInfo'
import { TruckingInfoPod } from '@/class/model/booking/TruckingInfoPod'
import { ChargeItem } from '@/class/model/mdm/chargeItem'
import { Charge } from '@/class/model/act/Charge'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'

export default {
  name: 'TabDestinationDelivery',
  components: {
    CargoDateTimeFieldInput, SoNoSelector, cargoAdvanceSelect, cargoCompanySelect,
    cargoRepeatValueSelect
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    from: {
      type: String,
      default: () => null
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      V3mail: {},
      loading: null,
      selectTypeNames: TYPE_NAMES,
      topgridApi: null,
      top: {
        visible: true,
        gridParams: {},
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: true,
          suppressCopyRowsToClipboard: true,
          context: {
            componentParent: this
          },
          // 选中 勾选框或者其他列 都会触发
          onCellFocused: (event) => {
            this.onCellFocused(event)
          },
          onRowClicked: this.selectionChangeHandler
        },
        columnDefs: [
          {
            headerName: this.$t('SeaExport.HaulageCompany'),
            field: 'carryingCmp',
            colId: 'carryingCmp',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            },
            lockVisible: true
          },
          {
            headerName: this.$t('SeaExport.HaulageNo'),
            field: 'truckOrderNo',
            colId: 'truckOrderNo',
            width: 150
          },
          {
            headerName: this.$t('SeaExport.Door'),
            field: 'doorName',
            colId: 'doorName',
            width: 150
          },
          {
            headerName: this.$t('SeaExport.ContactPerson'),
            field: 'driver',
            colId: 'driver',
            width: 100
          },
          {
            headerName: this.$t('SeaExport.Tel'),
            field: 'driverTel',
            colId: 'driverTel',
            width: 120
          },
          {
            headerName: this.$t('SeaExport.ContainerNo'),
            field: 'containerNo',
            colId: 'containerNo',
            width: 120,
            hide: true
          },
          {
            headerName: this.$t('SeaExport.Quantity'),
            field: 'quantity',
            colId: 'quantity',
            width: 100,
            hide: true
          },
          {
            headerName: this.$t('SeaExport.Weight'),
            field: 'weight',
            colId: 'weight',
            width: 100,
            hide: true
          },
          {
            headerName: this.$t('SeaExport.Cubage'),
            field: 'cubage',
            colId: 'cubage',
            width: 100,
            hide: true
          },
          {
            headerName: this.$t('SeaExport.DoorAddress'),
            field: 'doorAddr',
            colId: 'doorAddr',
            width: 200,
            hide: true
          },
          {
            headerName: this.$t('SeaExport.AdditionalNotes'),
            field: 'remarks',
            colId: 'remarks',
            width: 200,
            hide: true
          }
        ]
      },
      command1: this.$t('SeaExport.DispatchTuckOrder'),
      rowData: [],
      gridApi: null,
      gridParams: {},
      currentUser: {},
      job: new Job().fillDefaultValue().getData(),
      multiPickups: false,
      trucking: [],
      cityList: [],
      truckingInfo: new TruckingInfoPod().fillDefaultValue().getData(), // 初始化
      ieTruckInfo: new IntegratedTruckingInfo().fillDefaultValue().getData(), // 初始化
      soNo: '',
      btnEnable: {
        btDel: false
      },
      contactList: [],
      warehouseNameList: [],
      needReloadDriver: false, // 切换公司时, 重新读取司机信息, 否则不读取
      neednotReloadTelephone: false, // 表格内切换门点时, 不按照联系人名称重新读取电话
      needSaveCustomer: false, // 是否需要更新job.customer
      carryingContacts: [],
      doorList: [],
      matchOfRepeatDoor: options => {
        const option = options.find(p => p.contact === this.truckingInfo.doorMan)
        return option || options[0]
      },
      delTruckingInfoPodUuids: [], // 记录删除的uuid
      documentManage: new DocumentManage()
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    localCurrency() {
      return RateUtil.localCurrencyByOffice()
    }
  },
  async created() {
    await cache.load(cacheName.USER, cacheName.CONFIG)
    this.cityList = await getLocationList({}).then((res) => {
      return res.data.list || []
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    async onShow(row, isRefresh) {
      this.job = row
      if (!isRefresh) {
        // 需要刷新时 在startLoad里面处理
        await this.loadSites()
        return
      }
      this.currentUser = cache.user
      // 加载数据
      await this.startLoad(row)
      this.checkDefaultTrucking()
    },
    checkDefaultTrucking() {
      if (!this.job) return
      if (this.isEdit) {
        if (!this.trucking || this.trucking.length === 0) {
          this.createIntegratedTruckingInfo()
          this.truckingInfo.dischargingPortService = true
          this.truckingInfo.quantity = this.job.quantityActual
          this.truckingInfo.weight = this.job.weightActual
          this.truckingInfo.cubage = this.job.cubageActual
          this.truckingInfo.jobUuid = this.job.uuid
          this.truckingInfo.truckOrderNo = JobUtils.createTruckOrderNoForPod(this.job)
          this.trucking.push(this.truckingInfo)
        } else {
          this.setTruckingInfoData(this.job.truckingInfoPods[0])
          if (StrUtils.isEmpty(this.truckingInfo.truckOrderNo)) {
            this.truckingInfo.truckOrderNo = JobUtils.createTruckOrderNoForPod(this.job)
          }
        }
        this.selectionChangeHandler({ data: this.truckingInfo })
      }
    },
    sortTrucking(trucking) {
      return trucking.sort((a, b) => {
        const suffixA = a.truckOrderNo.replace(`${this.job.jobNo}_`, '')
        const suffixB = b.truckOrderNo.replace(`${this.job.jobNo}_`, '')
        return suffixA - suffixB
      })
    },
    async startLoad(row) {
      if (!this.job) return
      // 加载数据
      const job = new IntegratedJob(row)
      if (this.readonly || !job.truckingInfoPods || job.truckingInfoPods.length <= 0) {
        job.truckingInfoPods = ''
      }
      await Promise.all([
        job.getTruckingInfoPods(),
        this.loadSites()
      ])
      this.trucking = this.sortTrucking(job.truckingInfoPods)
      if (this.trucking && this.trucking.length > 0) {
        this.setTruckingInfoData(this.job.truckingInfoPods[0])
        if (StrUtils.isEmpty(this.truckingInfo.truckOrderNo)) {
          this.truckingInfo.truckOrderNo = JobUtils.createTruckOrderNoForPod(this.job)
        }
        this.$nextTick(async() => {
          // 等待gridApi被赋值
          await ensureExecuteSuccess(() => this.topgridApi)
          this.setGridSelect()
          this.selectionChangeHandler({ data: this.truckingInfo })
        })
      } else { // 非编辑没有门点信息，则默认为空
        if (!this.isEdit) {
          this.createIntegratedTruckingInfo()
          this.truckingInfo.dischargingPortService = true
        }
      }
    },
    onCellFocused(event) {
      this.$nextTick(async() => {
        // 等待gridApi被赋值
        await ensureExecuteSuccess(() => this.topgridApi)
        if (this.topgridApi && event.column) {
          this.topgridApi.forEachNode(node => {
            if (node.rowIndex === event.rowIndex) {
              node.setSelected(true)
              this.setTruckingInfoData(node.data)
            }
          })
        }
      })
    },
    // 设置 选中行(加载数据后默认选中第一行记录)
    setGridSelect(selectLastRow = false) {
      if (!this.job.multipleDischargingPickups) { return }
      const nodes = this.topgridApi ? this.topgridApi.getRenderedNodes() : []

      // 如无行记录数据，选中值重新设置
      if (!this.truckingInfo || nodes.length === 0) {
        this.createIntegratedTruckingInfo()
        this.truckingInfo.dischargingPortService = true
      }
      // 选中最后一行记录(用于 行复制 新增，删除)
      if (selectLastRow) {
        let index = 0
        for (const item of nodes) {
          if (index === nodes.length - 1) {
            item.setSelected(true)
            this.setTruckingInfoData(item.data)
            this.topgridApi.setFocusedCell(index, 'carryingCmp')
            break
          }
          index++
        }
      } else {
        // 默认选中第一个
        for (const item of nodes) {
          item.setSelected(true)
          this.setTruckingInfoData(item.data)
          this.topgridApi.setFocusedCell(0, 'carryingCmp')
          break
        }
      }
    },
    // 门店地址
    async loadSites() {
      // 同步实现 loadSiteResultHandler
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.job.customerId))
      if (!companyCache) return
      const companyUuid = companyCache.uuid
      if (!companyUuid) return
      await getSites(companyUuid).then(res => {
        this.doorList = res.data
      })
    },
    selectionChangeHandler(event) {
      if (!event.data) {
        return
      }
      this.V3mail = {
        truckingId: event.data.uuid
      }
      this.setTruckingInfoData(event.data)
      this.neednotReloadTelephone = true
      this.checkBtnsState()
      this.fillView()
      this.refreshGrid()
    },
    fillView() {
      if (!this.truckingInfo) return
      this.carringCapChange()
      this.refreshGrid()
    },
    // change carrying company
    async carringCapChange() {
      // 同步实现 carryingContactResultHandler
      if (!this.truckingInfo || this.truckingInfo.carryingCmp <= 0) return
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.truckingInfo.carryingCmp))
      if (!companyCache) {
        this.truckingInfo.carryingCmp = 0
        this.isNullData()
        return
      }
      const company = new Company({ cmpIdx: this.truckingInfo.carryingCmp })
      if (!company) return
      this.carryingContacts = await company.getContactsBycmpIdx()

      if (this.carryingContacts && this.carryingContacts.length > 0) {
        if (!this.truckingInfo.driver) {
          this.truckingInfo.driver = this.carryingContacts[0].contactPerson
        }
      } else {
        this.isNullData()
      }
      if (!this.truckingInfo.driver) return
      this.carryingContactsChangeHandler(this.needReloadDriver, this.neednotReloadTelephone)
    },
    isNullData() {
      this.carryingContacts = []
      this.truckingInfo.driver = ''
      this.truckingInfo.driverTel = ''
    },
    carryingContactsChangeHandler(needReloadDriver = false, needNotReloadTelephone = false) {
      if (!this.truckingInfo || !this.truckingInfo.driver) return
      this.neednotReloadTelephone = needNotReloadTelephone
      this.needReloadDriver = needReloadDriver
      // console.log('======================', value, this.carryingContacts, contact)
      if (this.carryingContacts && this.carryingContacts.length > 0) {
        for (const item of this.carryingContacts) {
          if (item && item.contactPerson && item.contactPerson === this.truckingInfo.driver) {
            if (!this.neednotReloadTelephone) {
              this.truckingInfo.driverTel = item.telephone
              break
            }
          }
        }
      } else {
        const contacts = this.carryingContacts
        if (contacts && contacts.length > 0 && this.needReloadDriver) {
          const cat = contacts[0]
          this.truckingInfo.driver = cat.contactPerson
          this.truckingInfo.driverTel = cat.telephone
        } else {
          this.truckingInfo.driver = ''
          if (this.needReloadDriver) {
            this.truckingInfo.driverTel = ''
          }
        }
      }
      this.refreshGrid()
    },
    setSelectDoor() {
      // 选中 门点，vue 双向绑定 不需要实现
    },
    checkBtnsState() {
      this.btnEnable.btDel = this.isEdit && this.truckingInfo != null
    },
    // 表单验证
    validate(isLastCheck = false) {
      if ((this.truckingInfo.carryingCmp === 0 || this.truckingInfo.carryingCmp === '') && (!isNaN(this.truckingInfo.truckingFee) && this.truckingInfo.truckingFee !== 0)) {
        if (isLastCheck) {
          throw new TabError(this.$t('Message.PleaseEnterTheShippingCompanyInformation'), 'tabDestinationDelivery')
        } else {
          this.$message.warning(this.$t('Message.PleaseEnterTheShippingCompanyInformation'))
          return false
        }
      }
      if (isLastCheck && this.trucking) {
        const truckingMap = {}
        for (const trucking of this.trucking) {
          if (StrUtils.isEmpty(trucking.truckOrderNo)) {
            continue
          }
          if (truckingMap.hasOwnProperty(trucking.truckOrderNo)) {
            if (isLastCheck) {
              throw new TabError(this.$t('Message.SameJobtruckOrderNo'), 'tabTruckingForSe')
            } else {
              this.$message.warning(this.$t('Message.SameJobtruckOrderNo'))
              return false
            }
          } else {
            truckingMap[trucking.truckOrderNo] = true
          }
        }
      }
      return true
    },
    createIntegratedTruckingInfo() {
      this.truckingInfo = new TruckingInfoPod().fillDefaultValue().getData()
      this.ieTruckInfo = this.truckingInfo.integratedTruckingInfo = new IntegratedTruckingInfo().fillDefaultValue().getData()
    },
    setTruckingInfoData(trucking) {
      this.truckingInfo = trucking
      if (this.truckingInfo.integratedTruckingInfo) {
        this.ieTruckInfo = this.truckingInfo.integratedTruckingInfo
      } else {
        // 兼容部分客户门点没有扩展表情况
        this.ieTruckInfo = this.truckingInfo.integratedTruckingInfo = new IntegratedTruckingInfo().fillDefaultValue().getData()
      }
    },
    // 复制新增
    copyNewHandler() {
      try {
        if (!this.truckingInfo || !this.trucking || this.trucking.length < 1) {
          this.$message.warning('请选择指定数据')
          return
        }
        if (this.truckingInfo && this.isEdit) {
          this.fillModel(false)
        }
        const item = this.truckingInfo
        if (this.validate()) {
          const trucking = new TruckingInfoPod().fillDefaultValue().getData()
          trucking.integratedTruckingInfo = new IntegratedTruckingInfo().fillDefaultValue().getData()
          trucking.jobUuid = this.job.uuid
          this.copyBasic(trucking, item)
          trucking.loadingDate = item.loadingDate
          trucking.actLoadingDate = item.actLoadingDate
          //	trucking.soNo = item.soNo;
          trucking.cubage = item.cubage
          trucking.plateNumber = item.plateNumber
          trucking.loadingPortService = item.loadingPortService
          trucking.dischargingPortService = item.dischargingPortService
          trucking.dischargingWay = item.dischargingWay
          trucking.po = item.po
          trucking.truckOrderNo = JobUtils.createTruckOrderNoForPod(this.job)
          // 复制新增时 派车单号 和拖车费不复制
          trucking.truckingFee = 0.00
          this.trucking.push(trucking)
          this.setTruckingInfoData(trucking)
          this.$nextTick(async() => {
            // 等待gridApi被赋值
            await ensureExecuteSuccess(() => this.topgridApi)
            this.setGridSelect(true)
            this.selectionChangeHandler({ data: trucking })
          })
        }
      } catch (err) {
        this.context.loading = false
        if (err instanceof TabError) {
          this.activeTabName = err.tabName
          if (err.message) {
            this.$message.warning({ dangerouslyUseHTMLString: true, message: err.message })
          }
          return
        }
        throw err
      }
    },
    // 新增
    addHandler() {
      if (this.truckingInfo && this.isEdit) {
        this.fillModel(false)
      }
      if (this.validate()) {
        const trucking = new TruckingInfoPod().fillDefaultValue().getData()
        trucking.integratedTruckingInfo = new IntegratedTruckingInfo().fillDefaultValue().getData()
        this.truckingInfo.dischargingPortService = true
        if (this.trucking.length === 0) {
          trucking.quantity = this.job.quantityActual
          trucking.weight = this.job.weightActual
          trucking.cubage = this.job.cubageActual
        }
        trucking.jobUuid = this.job.uuid
        // 新增的时候门点也清空
        trucking.doorName = ''
        trucking.doorMan = ''
        trucking.doorManTel = ''
        trucking.doorAddr = ''
        trucking.truckOrderNo = JobUtils.createTruckOrderNoForPod(this.job)
        this.trucking.push(trucking)
        this.truckingInfo = trucking
        this.ieTruckInfo = this.truckingInfo.integratedTruckingInfo
        this.$nextTick(() => {
          this.setGridSelect(true)
          this.selectionChangeHandler({ data: trucking })
        })
      }
    },
    // 删除
    delHandler() {
      // 去掉装箱信息和门点的关联（移至后端处理）
      this.truckingInfo.jobUuid = null
      if (this.job.truckingInfoPods.length > 0) {
        this.job.carryingCmp = this.trucking[0].carryingCmp
      } else {
        this.job.carryingCmp = 0
      }
      // 移除
      const index = this.trucking.indexOf(this.truckingInfo)
      if (this.truckingInfo.uuid && this.delTruckingInfoPodUuids.indexOf(this.truckingInfo.uuid) < 0) {
        this.delTruckingInfoPodUuids.push(this.truckingInfo.uuid)
      }
      if (index > -1) {
        this.trucking.splice(index, 1)
      }
      this.$nextTick(async() => {
        // 等待gridApi被赋值
        await ensureExecuteSuccess(() => this.topgridApi)
        this.setGridSelect(false)
        console.log('this.truckingInfo======2', this.truckingInfo.uuid)
        this.selectionChangeHandler({ data: this.truckingInfo })
      })
    },
    // 拖车费
    truckingFeeCharge() {
      if (this.truckingInfo && this.isEdit) {
        this.createCharge(true)
      }
    },
    async createCharge(isFinal) {
      if (!this.truckingInfo.truckingFee) {
        this.$nextTick(() => {
          this.truckingInfo.truckingFee = 0
        })
      }
      if (!isFinal) {
        return
      }
      const chargeCount = this.getCost()
      const amount = this.truckingInfo.truckingFee
      const truckingCount = this.job.truckingInfoPods ? this.job.truckingInfoPods.length : 0
      let charge = null
      let isCreate = true
      if (this.job.charges && this.job.charges.length > 0) {
        for (const c of this.job.charges) {
          if (c.truckOrderNo === this.truckingInfo.truckOrderNo) {
            isCreate = false
            charge = c // 先录费用后录拖车使用
            break
          }
        }
      }
      const chargeItemId = parseInt(cache.config.get('TruckingFeeCode')) // TRUCKING_FEE_CODE;
      const chargeItem = ChargeItem.getChargeItemById(chargeItemId)
      if (chargeItem && chargeItem.active && truckingCount > chargeCount && amount > 0 && isCreate) {
        charge = this.createNewCharge()
        charge.truckOrderNo = this.truckingInfo.truckOrderNo
        charge.chargeItemId = chargeItemId // TRUCKING_FEE_CODE;
        if (chargeItem.taxRate > 0) {
          charge.taxRate = chargeItem.taxRate
        }
        charge.unitPriceIncludeTax = parseInt(cache.config.get('InputIncludingTaxUnitPrice')) === 2
        // 其他tab 有charge 提交 需合并或其他方案待处理
        if (!this.job.charges) {
          this.job.charges = []
        }
        charge.serialNumber = this.job.charges.filter(p => !p.receivable).length + 1
        charge.isDirty = true
        this.job.charges.push(charge)
      }
      const shared = charge && (charge.shared || (charge.shareScheme && parseInt(charge.shareScheme) !== 0)) // 是否已分摊
      if (charge && charge.verifiedAmount === 0 && StrUtils.isEmpty(charge.billingUuid) && StrUtils.isEmpty(charge.billingPaymentUuid) && StrUtils.isEmpty(charge.invoiceUuid)) {
        if (!isNaN(amount) && amount > 0) {
          charge.accountId = this.truckingInfo.carryingCmp
          if (charge.uuid) {
            if (charge.chargeState === 0 && !charge.confirmState && !this.job.payableChargeLockedStatus && !shared) {
              charge.unitRate = amount
            }
          } else {
            charge.unitRate = amount
          }
          ChargeUtils.calculateTax(charge, parseFloat((charge.unitRate * charge.quantity).toFixed(2)), charge.taxRate, true)
          charge.isDirty = true
        }
      }

      // 设置开票抬头
      if (charge && charge.accountId && charge.accountId > 0) {
        await ChargeUtils.updateDefaultInvoiceTitle([charge])
      }
      this.context.reloadCharge = true
    },
    createNewCharge() {
      const charge = new Charge().fillDefaultValue().getData()
      charge.jobUuid = this.job.uuid
      charge.businessDate = this.job.businessDate
      charge.quantity = 1
      charge.localCurrency = this.localCurrency
      charge.currency = this.localCurrency
      charge.exchangeRate = 1
      charge.measure = 'NML'
      charge.receivable = false
      charge.oversea = false
      charge.verifiedAmount = 0
      charge.inputDate = new Date()
      charge.inputBy = this.currentUser.userId
      charge.branchId = this.$store.getters.currentOfficeId

      charge.inputByDep = this.job.opDepartment
      charge.businessDate = this.job.businessDate

      // 此处增加标识，费用页签再保存会导致费用重复生成
      charge.createdByOther = true
      return charge
    },
    // get job's trucking charge
    getCost() {
      // TRUCKING_FEE_CODE  默认拖车费
      const chargeCode = parseInt(cache.config.get('TruckingFeeCode'))
      let count = 0
      for (const charge of this.job.charges) {
        if (charge.chargeItemId === chargeCode && !charge.receivable) {
          count++
        }
      }
      return count
    },
    doorsChangeHandler(result) {
      this.truckingInfo.doorName = result.name
      this.truckingInfo.doorMan = ''
      this.truckingInfo.doorManTel = ''
      this.truckingInfo.doorAddr = ''
      if (result) {
        this.truckingInfo.doorMan = result.contact
        this.truckingInfo.doorManTel = result.phone
        this.truckingInfo.doorAddr = result.address
      }
      this.refreshGrid()
    },
    doorsChange2Handler(result) {
      this.ieTruckInfo.doorName = result.name
      this.ieTruckInfo.doorMan = ''
      this.ieTruckInfo.doorManTel = ''
      this.ieTruckInfo.doorAddress = ''
      if (result) {
        this.ieTruckInfo.doorMan = result.contact
        this.ieTruckInfo.doorManTel = result.phone
        this.ieTruckInfo.doorAddress = result.address
      }
      this.refreshGrid()
    },
    // 运输公司
    async carryingCmpChangeHandler() {
      if (!this.truckingInfo) return

      this.neednotReloadTelephone = false
      this.needReloadDriver = true
      this.job.carryingCmp = this.truckingInfo.carryingCmp
      this.truckingInfo.driver = ''
      this.truckingInfo.driverTel = ''
      this.carryingContacts = []
      await this.carringCapChange()
      this.refreshGrid()
      this.truckingFeeCharge()
    },
    getSubmitData() {
      this.validateForm()
      this.fillModel(false)
      const job = { ...this.job }
      const charges = []
      if (this.job.charges && this.job.charges.length > 0) {
        for (const charge of this.job.charges) {
          if (!charge.isDirty) continue
          charges.push(charge)
        }
      }
      const result = {
        job,
        truckingInfoPod: this.trucking,
        delTruckingInfoPodUuids: this.delTruckingInfoPodUuids
      }
      if (charges.length > 0) result.charges = charges
      return result
    },
    validateForm() {
      this.validate(true)
    },
    fillModel(isFinal = false) {
      // 判断门点 手工输入非 选择
      const door = this.doorList.find(item => item.name === this.truckingInfo.doorName)
      if (!door) { // new door
        this.needSaveCustomer = true
        this.newDoor(this.truckingInfo, this.truckingInfo.doorAddr)
      }
      const door2 = this.doorList.find(item => item.name === this.ieTruckInfo.doorName)
      if (!door2) { // new door
        this.needSaveCustomer = true
        this.newDoor(this.ieTruckInfo, this.ieTruckInfo.doorAddress)
      }
      this.createCharge(isFinal)
    },
    newDoor(truckingInfo, doorAddress) {
      if (!this.job.customerId || this.job.customerId === 0) {
        return
      }
      if (!truckingInfo.doorName) {
        return
      }
      // 填写内容是下拉框中的数据源
      const inputDoor = this.doorList.find(p => p.name === truckingInfo.doorName)
      if (inputDoor) {
        return
      }

      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.job.customerId))
      const door = {
        name: truckingInfo.doorName,
        contact: truckingInfo.doorMan,
        phone: truckingInfo.doorManTel,
        address: doorAddress,
        companyUuid: companyCache.uuid
      }
      addSites(door)
    },
    /**
     * 复制属性
     */
    copyBasic(target, source) {
      target.carryingCmp = source.carryingCmp
      target.doorAddr = source.doorAddr
      target.doorMan = source.doorMan
      target.doorManTel = source.doorManTel
      target.doorName = source.doorName
      target.cubage = source.cubage
      target.quantity = source.quantity
      target.weight = source.weight
      target.remarks = source.remarks
      // fix Bug 1750
      //			loadingDate = source.loadingDate;
      target.driver = source.driver
      target.driverTel = source.driverTel
    },
    refreshGrid() {
      if (this.topgridApi) {
        this.topgridApi.refreshCells({ force: true })
      }
    },
    selectContactBlur(event) {
      if (event && event.target && event.target.value) {
        this.truckingInfo.driver = event.target.value
      }
      this.refreshGrid()
    },
    endTabHandler() {
      this.job.truckingPage = true
    },
    nameChangeHandler(warehouseName) {
      this.job.truckWarehouseName = warehouseName
      const w = this.warehouseNameList.find(item => item.warehouseName === warehouseName)
      if (w) {
        this.job.truckWarehouseContactTel = w.warehouseContactTel
        this.job.truckWarehouseContact = w.warehouseContact
        this.job.truckWarehouseAddress = w.warehouseAddress
      } else {
        this.job.truckWarehouseContactTel = ''
        this.job.truckWarehouseContact = ''
        this.job.truckWarehouseAddress = ''
      }
    },
    async warehouseChangeHandler(warehouseCmp) {
      this.job.truckWarehouseCmp = warehouseCmp || 0

      this.isWarehouseNullData()
      await this.getContactList()
      await this.loadChargeHandler(warehouseCmp)
    },
    isWarehouseNullData() {
      this.warehouseNameList = []
      this.contactList = []
      this.job.truckWarehouseContactTel = ''
      this.job.truckWarehouseContact = ''
      this.job.truckWarehouseAddress = ''
      this.job.truckWarehouseName = ''
    },
    // 获取联系人
    async getContactList() {
      if (this.job.truckWarehouseCmp && parseInt(this.job.truckWarehouseCmp) > 0 && (!this.contactList || this.contactList.length <= 0)) {
        const company = new Company({ cmpIdx: this.job.truckWarehouseCmp })
        this.contactList = await company.getContactsBycmpIdx()
        this.isNeedLoadContact = false
      }
    },

    // 仓库更改-联动
    async loadChargeHandler(warehouseCmp) {
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(warehouseCmp))
      if (!companyCache) return

      // 获取公司下的仓库List & 默认仓库
      const warehouse = await this.getDefaultWarehouse(companyCache)
      if (warehouse) {
        this.job.truckWarehouseContactTel = warehouse.warehouseContactTel
        this.job.truckWarehouseContact = warehouse.warehouseContact
        this.job.truckWarehouseAddress = warehouse.warehouseAddress
        this.job.truckWarehouseName = warehouse.warehouseName
        this.contactsOldData(null, warehouse)
        // 从cargo 操作上看 此此处未使用 公司下的联系人 !this.openWarehouse &&
        if (!this.job.truckWarehouseContact && !this.job.truckWarehouseContactTel) {
          await this.loadContactsFunc()
        }
      } else {
        await this.loadContactsFunc()
      }
      this.getAddressText(companyCache, this.warehouseNameList)
    },
    async getDefaultWarehouse(companyCache) {
      // 获取公司下的仓库List
      const companyUuid = companyCache.uuid
      this.warehouseNameList = []
      await getWarehouseDetail(companyUuid).then(async res => {
        if (res.data.length > 0) {
          this.warehouseNameList = res.data
        }
      })
      // 获取 公司下的默认仓库
      let warehouseDefault = null
      for (const warehouse of this.warehouseNameList) {
        if (warehouse.defaultWarehouse) {
          warehouseDefault = warehouse
          break
        }
      }
      if (!warehouseDefault) {
        if (this.warehouseNameList && this.warehouseNameList.length > 0) {
          warehouseDefault = this.warehouseNameList[0]
        }
      }
      return warehouseDefault
    },
    /**
     * 旧的联系人控件添加数据
     * @param company
     * @param warehouseDetail
     */
    getAddressText(company, warehouseDetail) {
      if (!warehouseDetail || warehouseDetail.length === 0) {
        this.job.truckWarehouseAddress = company.address
      }
      if (warehouseDetail && warehouseDetail.length === 1) {
        const warehouse = warehouseDetail[0]
        if (StrUtils.isEmpty(warehouse.warehouseContactTel) &&
          StrUtils.isEmpty(warehouse.warehouseContact) &&
          StrUtils.isEmpty(warehouse.warehouseAddress)) {
          this.job.truckWarehouseAddress = company.address
        }
      }
    },
    async loadContactsFunc() {
      if (this.job.truckWarehouseCmp && parseInt(this.job.truckWarehouseCmp) > 0 && (!this.contactList || this.contactList.length <= 0)) {
        const company = new Company({ cmpIdx: this.job.truckWarehouseCmp })
        this.contactList = await company.getContactsBycmpIdx()
        this.isNeedLoadContact = false
      }
      if (this.contactList && this.contactList.length > 0) {
        for (const ct of this.contactList) {
          if (ct.defaultContact) {
            this.job.truckWarehouseContact = ct.contactPerson
            this.job.truckWarehouseContactTel = ct.telephone
            break
          }
        }
      } else {
        this.job.truckWarehouseContact = ''
        this.job.truckWarehouseContactTel = ''
      }
    },
    contactsOldData(wi, w) {
      if (wi || w) {
        const list = this.contactList
        const c = {
          telephone: '',
          contactPerson: ''
        }
        if (wi) {
          c.telephone = !wi.warehouseContactTel ? '' : wi.warehouseContactTel
          c.contactPerson = !wi.warehouseContact ? '' : wi.warehouseContact
        }
        if (w) {
          c.telephone = !w.warehouseContactTel ? '' : w.warehouseContactTel
          c.contactPerson = !w.warehouseContact ? '' : w.warehouseContact
        }
        let add = true
        for (const ct of list) {
          if (ct.contactPerson === c.contactPerson && ct.telephone === c.telephone) {
            add = false
            break
          }
        }
        if (add) {
          list.push(c)
        }
        this.contactList = list
      }
    },
    // 组装打印参数
    getPrintData() {
      const params = {}
      params.jobuuid = this.job.uuid
      params.V3mail = this.V3mail
      params.JOB_UUID = this.job.uuid
      params.TRUCKING_UUID = StrUtils.isEmpty(this.truckingInfo.uuid) ? null : this.truckingInfo.uuid
      params.USER_ID = this.currentUser.userId
      params.category = 'TRUCKING'
      params.ctx = new IntegratedJob(this.job)
      this.$logger.log('params', params)
      return params
    },
    multiPickupsChangeHandler() {
      if (!this.job.multipleDischargingPickups && this.trucking && this.trucking.length > 1) {
        const len = this.trucking.length
        for (let i = len - 1; i >= 1; i--) {
          // 移除
          const index = this.trucking.indexOf(this.trucking[i])
          if (this.trucking[i].uuid && this.delTruckingInfoPodUuids.indexOf(this.trucking[i].uuid) < 0) {
            this.delTruckingInfoPodUuids.push(this.trucking[i].uuid)
          }
          this.trucking.splice(index, 1)
        }
      }
      if (this.truckingInfo) {
        this.fillModel()
      }
      this.checkDefaultTrucking()
    },
    // 卡航换装时间同步
    changeReplacementTime(isAct = false) {
      if (!(this.job.dischargingPortDoor && !this.job.multipleDischargingPickups)) return
      if (isAct) {
        this.job.actReplacementTime = this.truckingInfo.actLoadingDate
      } else {
        this.job.estReplacementTime = this.truckingInfo.loadingDate
      }
    },
    // 卡航卸货时间同步
    changeDischargeTime(isAct = false) {
      if (!(this.job.dischargingPortDoor && !this.job.multipleDischargingPickups)) return
      if (isAct) {
        this.job.actDischargeTime = this.ieTruckInfo.actualArrivalDate
      } else {
        this.job.estDischargeTime = this.ieTruckInfo.arriveDate
      }
    },
    vehicleTypeLabel(item) {
      return JobUtils.vehicleTypeLabel(item)
    },
    contactsChangeHandler(contactPerson) {
      const w = this.contactList.find(item => item.contactPerson === contactPerson)
      if (w != null) {
        this.job.truckWarehouseContactTel = w.telephone
      }
    }
  }

}
</script>
<style lang="scss" scoped>
.inline-form {
  margin-left: 20px;

  label {
    font-weight: normal;
  }

  .el-form-item__content {
    & > label {
      width: 40px;
      display: inline-block;

      &:first-of-type {
        margin-left: 1px;
      }
    }

    .el-input-number {
      width: 86px;
      margin-right: 10px;
    }
  }

  .el-form-item {
    &:nth-of-type(2) {
      margin-left: 70px;
    }

    /deep/ .so-no-selector {
      & > span {
        &:first-of-type {
          flex: 1;
        }
      }
    }
  }
}

.trucking-form {
  width: 1200px;
  box-sizing: border-box;
  padding-left: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;

  .el-form {
    flex: 1;

    .el-form-item__content {
      & > label {
        margin: 0 10px;
        font-weight: normal;
      }

      span {
        &.currency {
          margin-left: 10px;
        }
      }
    }

    .plate_number {
      width: 400px;
      height: 28px;
      box-sizing: border-box;
      padding-left: 10px;
      vertical-align: middle;
      background-color: #f3f4f5;
      border: 1px solid #E4E7ED;
      display: inline-block;
    }

    .vehicle-btn {
      margin-left: 10px;
    }

    .vehicle-tip {
      margin-left: 5px;
      font-size: 16px;
      color: #1F75D5;
    }
  }
}

</style>
